import { render, staticRenderFns } from "./AppointmentResponsibleNotification.vue?vue&type=template&id=780be747&"
import script from "./AppointmentResponsibleNotification.vue?vue&type=script&lang=js&"
export * from "./AppointmentResponsibleNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('780be747')) {
      api.createRecord('780be747', component.options)
    } else {
      api.reload('780be747', component.options)
    }
    module.hot.accept("./AppointmentResponsibleNotification.vue?vue&type=template&id=780be747&", function () {
      api.rerender('780be747', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/notification/types/AppointmentResponsibleNotification.vue"
export default component.exports